/* eslint-disable camelcase */
import React from 'react';

import PropTypes from 'prop-types';

import { useBreakpoint } from '~/techstyle-shared/react-components';

import DesktopGridLayout from './components/DesktopGridLayout';
import MobileGridLayout from './components/MobileGridLayout';
import { useAutoFilters } from './hooks/useAutofilters';
import { BuilderConstructorGridInputProvider } from './hooks/useBuilderConstructorGridInputs';

const BuilderConstructorGridV1_1 = ({
  builderState,
  assetContainer,
  filterType,
  collectionId,
  collectionSelection,
  collectionIdOverride,
  categoryId,
  categorySelection,
  categoryIdOverride,
  facet,
  facetOption,
  gridGender,
  gridHeader,
  gridStyleGuide,
  sortOptions,
  sideNav,
  productSource,
}) => {
  const { isMobile } = useBreakpoint();

  useAutoFilters({ builderState, gridGender });

  return (
    <BuilderConstructorGridInputProvider
      value={{
        builderState,
        assetContainer,
        filterType,
        collectionId,
        collectionSelection,
        collectionIdOverride,
        categoryId,
        categorySelection,
        categoryIdOverride,
        facet,
        facetOption,
        gridGender,
        gridHeader,
        gridStyleGuide,
        sortOptions,
        sideNav,
        productSource,
      }}
    >
      {isMobile ? <MobileGridLayout /> : <DesktopGridLayout />}
    </BuilderConstructorGridInputProvider>
  );
};

BuilderConstructorGridV1_1.propTypes = {
  assetContainer: PropTypes.shape({
    gridAssetContainer: PropTypes.string,
    gridAssetContainerMobile: PropTypes.string,
  }),
  builderState: PropTypes.object,
  categoryId: PropTypes.string,
  categoryIdOverride: PropTypes.string,
  categorySelection: PropTypes.shape({
    value: PropTypes.string,
  }),
  collectionId: PropTypes.string,
  collectionIdOverride: PropTypes.string,
  collectionSelection: PropTypes.shape({
    value: PropTypes.string,
  }),
  facet: PropTypes.string,
  facetOption: PropTypes.string,
  filterType: PropTypes.string,
  gridGender: PropTypes.string,
  gridHeader: PropTypes.string,
  gridStyleGuide: PropTypes.string,
  productSource: PropTypes.string,
  sideNav: PropTypes.object,
  sortOptions: PropTypes.array,
};

export default BuilderConstructorGridV1_1;
